import { verificationApi } from '@api/index';
import { useAuth } from '@hooks/useAuth';
import { useQuery } from '@hooks/useQuery';
import { VERIFICATION_STATUS } from '@interfaces/user';

const PENDING_FUTURES_REFETCH_INTERVAL = 5000;

export const useVerificationRequestQuery = () => {
  const { refreshUser } = useAuth();

  const query = useQuery(['verification-request'], () => verificationApi.request(), {
    onSuccess: async (data) => {
      if (data.status === VERIFICATION_STATUS.VERIFIED) {
        await refreshUser();
      }
    },
    refetchInterval: (data) =>
      data?.status === VERIFICATION_STATUS.PENDING_FUTURES
        ? PENDING_FUTURES_REFETCH_INTERVAL
        : false,
  });

  return query;
};
